// extracted by mini-css-extract-plugin
module.exports = {"blTit":"BlogFP_blTit__1slo1","blogsMainD":"BlogFP_blogsMainD__2-Zyk","blogSubInd":"BlogFP_blogSubInd__1bUwW"};